var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1117_5031)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1117_5031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1117_5031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.25C0 1.00736 1.00736 0 2.25 0H18.75C19.9926 0 21 1.00736 21 2.25V7.875C21 8.49631 20.4963 9 19.875 9C19.2537 9 18.75 8.49631 18.75 7.875V3C18.75 2.58579 18.4142 2.25 18 2.25H3C2.58579 2.25 2.25 2.58579 2.25 3V19.5C2.25 19.9142 2.58579 20.25 3 20.25H9.375C9.99631 20.25 10.5 20.7537 10.5 21.375C10.5 21.9963 9.99631 22.5 9.375 22.5H2.25C1.00736 22.5 0 21.4926 0 20.25V2.25ZM5.625 6C5.00369 6 4.5 6.50369 4.5 7.125C4.5 7.74631 5.00369 8.25 5.625 8.25L15.375 8.24997C15.9963 8.24997 16.5 7.74628 16.5 7.12497C16.5 6.50365 15.9963 5.99997 15.375 5.99997L5.625 6ZM4.5 11.625C4.5 11.0037 5.00369 10.5 5.625 10.5H10.875C11.4963 10.5 12 11.0037 12 11.625C12 12.2463 11.4963 12.75 10.875 12.75H5.625C5.00369 12.75 4.5 12.2463 4.5 11.625ZM16.5 13.125C16.5 12.5037 17.0037 12 17.625 12C18.2463 12 18.75 12.5037 18.75 13.125V16.5H22.125C22.7463 16.5 23.25 17.0037 23.25 17.625C23.25 18.2463 22.7463 18.75 22.125 18.75H18.75V22.125C18.75 22.7463 18.2463 23.25 17.625 23.25C17.0037 23.25 16.5 22.7463 16.5 22.125V18.75H13.125C12.5037 18.75 12 18.2463 12 17.625C12 17.0037 12.5037 16.5 13.125 16.5H16.5V13.125Z",
    fill: "#42474D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1117_5031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.140d60f231e63b699309c4274f0cf1ef.svg";
export { ForwardRef as ReactComponent };